<style src="./styles.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="container row">
      <CreditorList @edit-mode="enterEditMode" ref="CreditorListRef" />
      <div class="col-md-6">
        <form @submit.prevent="createCreditor">
          <h3>Identificação</h3>

          <div class="form-group">
            <label>Código</label>
            <input type="text" class="form-control" v-model="form.code" />
          </div>

          <h4>Tipo de Credor</h4>
          <div class="row">
            <div class="form-group col-md-4">
              <input
                type="radio"
                class="form-check-input"
                v-model="form.creditorType"
                :value="creditorType.PROVIDER"
              />
              <label> Fornecedor</label>
            </div>
            <div class="form-group col-md-4">
              <input
                type="radio"
                class="form-check-input"
                v-model="form.creditorType"
                :value="creditorType.BROKER"
              />
              <label> Corretor</label>
            </div>
          </div>

          <h4>Tipo de Pessoa</h4>
          <div class="row">
            <div class="form-group col-md-4">
              <input
                type="radio"
                class="form-check-input"
                v-model="form.personType"
                :value="personType.PHYSICAL"
              />
              <label> Física</label>
            </div>
            <div class="form-group col-md-4">
              <input
                type="radio"
                class="form-check-input"
                v-model="form.personType"
                :value="personType.LEGAL"
              />
              <label> Jurídica</label>
            </div>
          </div>
          <br />
          <div v-if="form.personType === personType.PHYSICAL">
            <div class="row">
              <div class="form-group col-md-6">
                <label>CPF</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.physical.cpf"
                />
              </div>
              <div class="form-group col-md-6">
                <label>Nome</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.physical.name"
                />
              </div>
            </div>
            <div class="form-group">
              <label>Descição</label>
              <input
                type="text"
                class="form-control"
                v-model="form.physical.description"
              />
            </div>
          </div>

          <div v-else>
            <div class="row">
              <div class="form-group col-md-6">
                <label>CNPJ</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.legal.cnpj"
                />
              </div>
              <div class="form-group col-md-4 button-conteiner">
                <div class="space-25"></div>
                <button
                  type="button"
                  class="btn btn-sm btn-primary col-md-12"
                  disabled
                  @click="searchCPNJ"
                >
                  <i class="fa fa-search"></i>
                  Buscar
                </button>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label>Razão social</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.legal.companyName"
                />
              </div>
              <div class="form-group col-md-6">
                <label>Fantasia</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.legal.fantasyfantasy"
                />
              </div>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-inpu"
                v-model="form.legal.microEnterprise"
              />
              <label class="form-check-label"> Microempresa</label>
            </div>
          </div>
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-inpu"
              v-model="form.transporter"
            />
            <label class="form-check-label"> Trasnportadora</label>
          </div>
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-inpu"
              v-model="form.foreigner"
            />
            <label class="form-check-label"> Estrangeiro</label>
          </div>
          <h3>Endereço</h3>
          <div class="form-group">
            <label>Endereço</label>
            <input
              type="text"
              class="form-control"
              v-model="form.address.name"
            />
          </div>
          <div class="form-group">
            <label>Complemento</label>
            <input
              type="text"
              class="form-control"
              v-model="form.address.complement"
            />
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label>Bairro</label>
              <input
                type="text"
                class="form-control"
                v-model="form.address.neighborhood"
              />
            </div>
            <div class="form-group col-md-6">
              <label>Cidade</label>
              <input
                type="text"
                class="form-control"
                v-model="form.address.city"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-8">
              <label>E-mail</label>
              <input
                type="text"
                class="form-control"
                v-model="form.address.email"
              />
            </div>
            <div class="form-group col-md-4">
              <label>CEP</label>
              <input
                type="text"
                class="form-control"
                v-model="form.address.zipCode"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label>Telefone Primário</label>
              <input
                type="text"
                class="form-control"
                v-model="form.address.phone"
              />
            </div>
            <div class="form-group col-md-6">
              <label>Telefone Secundário</label>
              <input
                type="text"
                class="form-control"
                v-model="form.address.secondaryPhone"
              />
            </div>
          </div>
          <h3>Pagamento</h3>
          <div class="row">
            <div class="form-group col-md-4">
              <label>Código do banco</label>
              <input
                type="text"
                class="form-control"
                v-model="form.paymentInfo.bankCode"
              />
            </div>
            <div class="form-group col-md-4">
              <label>Agência</label>
              <input
                type="text"
                class="form-control"
                v-model="form.paymentInfo.agency"
              />
            </div>
            <div class="form-group col-md-4">
              <label>Número da conta</label>
              <input
                type="text"
                class="form-control"
                v-model="form.paymentInfo.accountNumber"
              />
            </div>
          </div>
          <div class="from-group">
            <label>Conta</label>
            <select class="form-control" v-model="form.paymentInfo.account">
              <option
                v-for="(item, index) in accounts"
                :key="index"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>Favorecido</label>
            <input
              type="text"
              class="form-control"
              v-model="form.paymentInfo.destiny"
            />
          </div>
          <div class="row">
            <div class="form-group col-md-4">
              <label>Chave PIX</label>
              <input
                type="text"
                class="form-control"
                v-model="form.paymentInfo.pixKey"
              />
            </div>
            <div class="form-group col-md-4">
              <label>Código PIX</label>
              <input
                type="text"
                class="form-control"
                v-model="form.paymentInfo.pixCode"
              />
            </div>
            <div class="form-group col-md-4">
              <label>CPF/CNPJ PIX</label>
              <input
                type="text"
                class="form-control"
                v-model="form.paymentInfo.pixCpfCnpj"
              />
            </div>
          </div>
          <div class="form-group">
            <label>Favorecido PIX</label>
            <input
              type="text"
              class="form-control"
              v-model="form.paymentInfo.pixDestiny"
            />
          </div>
          <button
            class="btn btn-block btn-primary compose-mail"
            href="mail_compose.html"
            v-if="!editMode.active"
          >
            <i class="fa fa-save"></i>
            Criar Credor
          </button>

          <div v-if="editMode.active">
            <button
              type="button"
              class="btn btn-outline"
              href="mail_compose.html"
              @click="exitEditMode"
            >
              Cancelar
            </button>

            <button
              type="button"
              class="btn btn-warning pull-right"
              href="mail_compose.html"
              @click="saveCreditor"
            >
              <i class="fa fa-save"></i>
              Salvar Credor
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import CreditorList from './components/creditor-list/CreditorList';
import { toast } from '@/plugins/toast';

const CreditorType = {
  PROVIDER: 'provider',
  BROKER: 'broker',
};
const PersonType = {
  PHYSICAL: 'physical',
  LEGAL: 'legal',
};
const AccountType = {
  CHECKING_ACCOUNT: {
    value: 'CheckingAccount',
    label: 'Conta Corrente',
  },
  SAVINGS_ACCOUNT: {
    value: 'SavingsAccount',
    label: 'Conta Poupança',
  },
  SALARY_ACCOUNT: {
    value: 'SalaryAccount',
    label: 'Conta Salário',
  },
};
export default {
  components: {
    CreditorList,
  },
  data() {
    return {
      creditorType: CreditorType,
      personType: PersonType,
      accountType: AccountType,
      accounts: AccountType,
      editMode: {
        active: false,
        creditorId: '',
      },
      form: {
        code: '',
        creditorType: CreditorType.PROVIDER,
        personType: PersonType.PHYSICAL,
        physical: {
          cpf: '',
          name: '',
          description: '',
        },
        legal: {
          cnpj: '37954368000107',
          companyName: '',
          fantasy: '',
          microEnterprise: false,
        },
        transporter: false,
        foreigner: false,
        address: {
          name: '',
          complement: '',
          neighborhood: '',
          city: '',
          zipCode: '',
          email: '',
          phone: '',
          secondaryPhone: '',
        },
        paymentInfo: {
          bankCode: '',
          agency: '',
          accountNumber: '',
          account: AccountType.CHECKING_ACCOUNT.value,
          destiny: '',
          pixKey: '',
          pixCode: '',
          pixCpfCnpj: '',
          pixDestiny: '',
        },
      },
    };
  },

  methods: {
    async searchCPNJ() {
      try {
        if (!this.form.legal.cnpj) {
          return;
        }
        const response = await fetch(
          `https://www.receitaws.com.br/v1/cnpj/${this.form.legal.cnpj}`,
          {
            method: 'GET',
            headers: [
              ['Content-Type', 'application/json'],
              ['Content-Type', 'text/plain'],
              ['Access-Control-Allow-Origin', '*'],
              ['Access-Control-Allow-Headers', '*'],
            ],
            credentials: 'include',
          },
        );

        if (response.status >= 400) {
          throw new Error('Was not possible get this CNPJ');
        }
        const responseJSON = await response.json();
        console.info('responseJSON', responseJSON);
      } catch (error) {
        console.error(error);
        toast.error('Falha ao buscar CNPJ');
      }
    },
    enterEditMode(creditor) {
      this.editMode = {
        active: true,
        creditorId: creditor._id,
      };
      this.form.code = creditor.code;
      this.form.creditorType = creditor.creditorType;
      this.form.personType = creditor.personType;
      if (creditor.physical) {
        this.form.physical = {
          cpf: creditor.physical.cpf,
          name: creditor.physical.name,
          description: creditor.physical.description,
        };
      }
      if (creditor.legal) {
        this.form.legal = {
          cnpj: creditor.legal.cnpj,
          companyName: creditor.legal.companyName,
          fantasy: creditor.legal.fantasy,
          microEnterprise: creditor.legal.microEnterprise,
        };
      }
      this.form.transporter = creditor.transporter;
      this.form.foreigner = creditor.foreigner;
      this.form.address = {
        name: creditor.address.name,
        complement: creditor.address.complement,
        neighborhood: creditor.address.neighborhood,
        city: creditor.address.city,
        zipCode: creditor.address.zipCode,
        email: creditor.address.email,
        phone: creditor.address.phone,
        secondaryPhone: creditor.secondaryPhone,
      };
      this.form.paymentInfo = {
        bankCode: creditor.paymentInfo.bankCode,
        agency: creditor.paymentInfo.agency,
        accountNumber: creditor.paymentInfo.accountNumber,
        account: creditor.paymentInfo.account,
        destiny: creditor.paymentInfo.destiny,
        pixKey: creditor.paymentInfo.pixKey,
        pixCode: creditor.paymentInfo.pixCode,
        pixCpfCnpj: creditor.paymentInfo.pixCpfCnpj,
        pixDestiny: creditor.paymentInfo.pixDestiny,
      };
    },
    exitEditMode() {
      this.editMode = {
        active: false,
        creditorId: '',
      };
      this.form.code = '';
      this.form.creditorType = CreditorType.PROVIDER;
      this.form.personType = PersonType.PHYSICAL;
      this.form.physical = {
        cpf: '',
        name: '',
        description: '',
      };
      this.form.legal = {
        cnpj: '',
        companyName: '',
        fantasy: '',
        microEnterprise: '',
      };
      this.form.transporter = '';
      this.form.foreigner = '';
      this.form.address = {
        name: '',
        complement: '',
        neighborhood: '',
        city: '',
        zipCode: '',
        email: '',
        phone: '',
        secondaryPhone: '',
      };
      this.form.paymentInfo = {
        bankCode: '',
        agency: '',
        accountNumber: '',
        account: '',
        destiny: '',
        pixKey: '',
        pixCode: '',
        pixCpfCnpj: '',
        pixDestiny: '',
      };
    },
    async saveCreditor() {
      try {
        const payload = {
          code: this.form.code,
          creditorType: this.form.creditorType,
          personType: this.form.personType,
          transporter: this.form.transporter,
          foreigner: this.form.foreigner,
          address: this.form.address,
          paymentInfo: this.form.paymentInfo,
        };
        if (payload.personType === PersonType.PHYSICAL) {
          payload.physical = this.form.physical;
        } else {
          payload.legal = this.form.legal;
        }

        await this.$store.dispatch('FINANCIAL-ACCOUNT/UpdateCreditor', {
          payload,
          creditorId: this.editMode.creditorId,
        });
        this.exitEditMode();
        toast.success('Credor atualizado com sucesso');
        this.$refs.CreditorListRef.loadCreditors();
      } catch (error) {
        toast.error('Falha ao criar credor');
      }
    },
    async createCreditor() {
      try {
        const payload = {
          code: this.form.code,
          creditorType: this.form.creditorType,
          personType: this.form.personType,
          transporter: this.form.transporter,
          foreigner: this.form.foreigner,
          address: this.form.address,
          paymentInfo: this.form.paymentInfo,
        };
        if (payload.personType === PersonType.PHYSICAL) {
          payload.physical = this.form.physical;
        } else {
          payload.legal = this.form.legal;
        }
        await this.$store.dispatch('FINANCIAL-ACCOUNT/CreateCreditor', payload);
        this.exitEditMode();
        toast.success('Credor criado com sucesso');
        this.$refs.CreditorListRef.loadCreditors();
      } catch (error) {
        toast.error('Falha ao criar credor');
      }
    },
  },
};
</script>